export type TripStatus =
  | 'scheduled'
  | 'dispatched'
  | 'in_progress'
  | 'completed'
  | 'cancelled';

const TRANSITIONS: Record<TripStatus, TripStatus[]> = {
  scheduled: ['dispatched', 'cancelled'],
  dispatched: ['in_progress', 'cancelled'],
  in_progress: ['completed'],
  completed: [],
  cancelled: [],
};

export function getAllowedNextStatuses(current: TripStatus): TripStatus[] {
  return TRANSITIONS[current] ?? [];
}

export function canTransition(from: TripStatus, to: TripStatus): boolean {
  if (from === to) return true;
  return getAllowedNextStatuses(from).includes(to);
}

export function canEditTrip(status: TripStatus): boolean {
  return status === 'scheduled';
}

export function canCancelTrip(status: TripStatus): boolean {
  return status === 'scheduled' || status === 'dispatched';
}

export function shouldAutoDispatch(
  vehicleId?: string | null,
  driverId?: string | null,
  status?: TripStatus | null
): boolean {
  return !!(vehicleId && driverId && (!status || status === 'scheduled'));
}

export function shouldDemoteToScheduled(
  vehicleId?: string | null,
  driverId?: string | null
): boolean {
  return !!vehicleId && !driverId;
}
